import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IBuilding } from 'src/app/building-managment/building-management-interfaces';
import { IDevice } from 'src/app/building-managment/building-unit-details/add-lock/lock-management-interfaces';
import { getFullName } from 'src/app/shared/utils/full-name.util';
import { PopupProfile } from '../profile-management.service';
import { AssignFloor, AssignUnit } from '../profile-assign-unit/profile-assign-unit.component';

export interface ReviewUnit {
  unitId: string;
  label: string;
  floorName: string;
  wingName?: string;
}

const byName = (a?: string, b?: string) =>
  (a || '').localeCompare(b || '', undefined, { numeric: true });

// Selected units in the same floor/unit order as the unit selection popup.
export function buildReviewUnits(floors: AssignFloor[], selectedUnits: AssignUnit[]): ReviewUnit[] {
  const selectedIds = new Set((selectedUnits || []).map(unit => unit.unitId));
  const rows: ReviewUnit[] = [];
  [...(floors || [])]
    .sort((a, b) => byName(a.floorName, b.floorName))
    .forEach(floor => [...floor.units]
      .sort((a, b) => byName(a.unitName, b.unitName))
      .filter(unit => selectedIds.has(unit.unitId))
      .forEach(unit => rows.push({
        unitId: unit.unitId,
        label: unit.label,
        floorName: floor.floorName,
        wingName: floor.wingName,
      })));
  return rows;
}

@Component({
  selector: 'app-profile-review-access',
  templateUrl: './profile-review-access.component.html',
  styleUrls: ['./profile-review-access.component.scss'],
})
export class ProfileReviewAccessComponent {
  @Input() profileDetails!: PopupProfile;
  @Input() building?: IBuilding;
  @Input() floors: AssignFloor[] = [];
  @Input() selectedUnits: AssignUnit[] = [];
  @Input() reviewMode: 'units' | 'locks' = 'units';
  @Input() selectedLocks: IDevice[] = [];
  @Output() continueRequested = new EventEmitter<IDevice[]>();
  @Input() dialogRef?: { close: () => void };
  @Input() stepper = 22;
  @Output() stepperChange = new EventEmitter<number>();
  expanded = true;

  get userName(): string {
    const p = this.profileDetails;
    return getFullName(p?.firstName, p?.middleName, p?.lastName);
  }

  get reviewUnits(): ReviewUnit[] {
    return buildReviewUnits(this.floors, this.selectedUnits);
  }

  get selectedUnit(): AssignUnit | undefined {
    return this.selectedUnits[0];
  }

  get lockLocation(): string {
    const floor = this.floors.find(item => item.floorId === this.selectedUnit?.floorId);
    return [floor?.floorName, this.building?.buildingName].filter(Boolean).join(', ');
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  continue(): void {
    if (this.reviewMode === 'locks') {
      if (this.selectedLocks.length) this.continueRequested.emit(this.selectedLocks);
      return;
    }
    this.stepperChange.emit(23);
  }

  editAccess(): void {
    this.stepperChange.emit(this.reviewMode === 'locks' ? 34 : 21);
  }

  close(): void {
    this.dialogRef?.close();
  }
}
